import React from 'react';
import { getAppState, getFirstName } from '../../selectors';
import { connect } from 'react-redux';

import NavHeader from "./nav.header";

const content = {
  decline: (state, dispatch, focusableRef) => (
    <article className="page-header-content">
      <h1 className="truncate">Thanks for applying, <strong className="text-capitalize">{getFirstName(state)}</strong>!</h1>
    </article>
  ),

  applicationPended: (state, dispatch, focusableRef) => (
    <article className="page-header-content">
      <h1 className="truncate" >Thanks for applying, <strong className="text-capitalize">{getFirstName(state)}</strong>!</h1>
      <p ref={focusableRef} tabIndex="-1">Proceed to Application center to continue</p>
    </article>
  ),

  verid: (state, dispatch, focusableRef) => (
    <article className="page-header-content">
      <h1 className="truncate" ref={focusableRef} tabIndex="-1">Help us confirm your <strong>identity</strong></h1>
      <p>Please answer the questions to the best of your ability.</p>
    </article>
  ),

  applicationApproved: (state, dispatch, focusableRef) => (
    <article className="page-header-content">
      <h1 className="truncate" ref={focusableRef} tabIndex="-1"><strong className="text-capitalize">{getFirstName(state)}</strong>, your personal loan has been approved!</h1>
      <p>Click the Application Center button to view your loan offer.</p>
    </article>
  )
};

export const Header = ({ state, dispatch, focusableRef }) => {
  const headerStyles = ['page-header'];
  headerStyles.push(state.step);
  if (['miniApp', 'quotes', 'fullApp'].includes(state.step)) {
    headerStyles.push('sticky-top');
  }

  return (
    <header id="topHeader" className={headerStyles.join(' ')}>
      <NavHeader showNavigationLinks={ false }/>
      { content[state.step] ? content[state.step](state, dispatch, focusableRef) : ''}
    </header>
  );
};

const mapStateToProps = (state, ownProps) => ({
  state: getAppState(state),
  ...ownProps
});

export default connect(mapStateToProps)(Header);
